import {
    BillingHistory,
    BillingInfo,
    BillingStatus,
} from "@common/types/billing";
import { BillingStatusDto } from "@common/dto/billing/billing-status.dto";
import { billingContract } from "@common/contracts/billing.contract";
import { backendClient, unwrapResponse } from "./backendClient";
import { getBackendAPIClient } from "./backendAPIClient";

const billingContractClient = getBackendAPIClient(billingContract);

export async function getBillingStatus(
    workspaceId: string,
): Promise<BillingStatus> {
    return BillingStatusDto.deserialize(
        unwrapResponse(
            await backendClient.get(`/billing/billing-status/${workspaceId}`),
        ),
    );
}

export async function getBillingInfo(
    workspaceId?: string,
): Promise<BillingInfo | null> {
    if (workspaceId) {
        const response = await billingContractClient.getBillingInfoForWorkspace(
            {
                params: { workspaceId },
            },
        );
        if (response.status === 200) {
            return response.body;
        }
        throw new Error(
            response.status === 404
                ? "Workspace not found"
                : "Failed to fetch billing info",
        );
    }

    const response = await billingContractClient.getBillingInfo();
    if (response.status === 200) {
        return response.body;
    }
    throw new Error("Failed to fetch billing info");
}

export async function getBillingHistory(): Promise<BillingHistory> {
    const response = await billingContractClient.getBillingHistory();

    if (response.status !== 200) {
        throw new Error("Failed to fetch billing history");
    }

    return {
        invoices: response.body.invoices.map((invoice) => ({
            ...invoice,
            date: new Date(invoice.date),
        })),
    };
}
